import { render, staticRenderFns } from "./SalesSupportStat.vue?vue&type=template&id=c0db3d54&"
import script from "./SalesSupportStat.vue?vue&type=script&lang=js&"
export * from "./SalesSupportStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports